export default __webpack_public_path__ + "static/media/4.9ac3d0f4.png";